function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.in{fill:#0F82B7;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  id: "LinkedIn_3_",
  className: "in",
  d: "M512,311.4v189.2H402.2V324c0-44.4-15.8-74.6-55.6-74.6c-30.4,0-48.3,20.4-56.3,40.1 c-2.9,7.1-3.8,17-3.8,26.8v184.3H176.9c0,0,1.5-299.1,0-330.1h109.7v46.8c-0.1,0.4-0.5,0.7-0.6,1.1h0.6v-1.1 c14.7-22.5,40.6-54.5,98.9-54.5C457.9,162.8,512,210,512,311.4z M62.1,11.4C24.6,11.4,0,36,0,68.5c0,31.6,23.9,57,60.7,57h0.7 c38.4,0,62.1-25.5,62.1-57C122.7,36,99.7,11.4,62.1,11.4z M6.5,500.6h109.7V170.5H6.5V500.6z"
}));

var SvgLinkedInLogo = function SvgLinkedInLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedInLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linked-in-logo.efe2f788.svg";
export { ForwardRef as ReactComponent };